module.exports = __webpack_public_path__ + "img/camera.e48e13c8.svg";